import React from 'react';
import ReportCardsDashboard from './ReportCardsDashboard';

export default function ReportCardPage() {
  return <ReportCardsDashboard />;
}
